<div
  [ngClass]="notification()?.title?.length > 120 ? 'tw-cursor-pointer' : ''"
  #notificationElement
  [notificationsBackground]="notification().importanceLevel"
  class="relative tw-flex tw-flex-col tw-justify-start tw-items-center tw-mt-4 tw-p-3 tw-border tw-border-gray-300 dark:tw-border-slate-700 tw-rounded-md tw-relative tw-min-h-[50px]"
>
  <!-- title  -->
  <p
    (click)="onShowDetailNotificationToggle(notificationElement, $event)"
    class="tw-max-w-[330px] tw-self-start notification-msg tw-text-base tw-font-medium tw-duration-500 tw-transition-[height] tw-w-full dark:tw-text-gray-300 max-two-row"
  >
    <!-- delete btn  -->
    <span
      *ngIf="!notification().isSeen"
      [inlineSVG]="'/assets/media/icons/duotune/arrows/arr061.svg'"
      class="cursor-pointer tw-inline-block svg-icon svg-icon-danger tw-w-[18px] tw-h-[12px]"
      (click)="notificationSeenApi(notification().notificationId)"
    ></span>

    <!-- [notificationsIcon]="notification().importanceLevel" -->
    <span>
      {{ notification().title }}
    </span>

    <!-- buy plan btn  -->
    @if( notification().notificationTypes ==
    NotificationTypes.OrganizationExpiration){
    <a
      (click)="openTab('buyPlanPackage')"
      class="group tw-w-[140px] tw-text-[12px] tw-h-[30px] tw-flex-center tw-py-1 tw-px-2 tw-rounded-md tw-bg-gray-500 dark:tw-bg-gray-600 hover:tw-bg-blue-700 dark:hover:tw-bg-blue-700"
      style="border-color: unset !important"
    >
      <span>
        <span
          class="mdi mdi-18px mdi-shopping tw-text-gray-100 group-hover:tw-text-gray-50"
        ></span>
        <span class="tw-text-gray-100 group-hover:tw-text-gray-50">
          {{ "common.buyPlan" | translate }}</span
        >
      </span>
    </a>
    }
  </p>

  <!-- notification date  -->
  <div
    class="tw-flex tw-w-full tw-justify-between tw-items-center"
    [ngClass]="notification().notificationId != 0 ? 'tw-cursor-pointer' : ''"
  >
    <div class="tw-text-sm tw-text-gray-500 tw-font-normal tw-mt-2">
      <span>
        <i
          class="mdi mdi-20px"
          [notificationsIcon]="notification().importanceLevel"
        ></i
      ></span>
      <!-- seen btn  -->
      <!-- <span>
      <i
        class="mdi mdi-22px mdi-check-all tw-mx-1"
        [matTooltip]="'common.readNotification' | translate"
        (click)="notificationSeenApi(notification().notificationId)"
        [class]="
          notification().notificationId != 0
            ? 'text-success'
            : 'text-gray tw-opacity-30'
        "
      ></i>
    </span> -->

      <!-- created -->
      <span> {{ notification().created | convertDateToTime : "fa-IR" }}</span>
      <span
        class="tw-mx-1 dir-ltr tw-text-sm"
        *ngIf="
          (notification().created
            | dateTimeConvertor : appStateService.currentAppLang()) != '-'
        "
      >
        (
        <span>
          {{
            (
              notification().created
              | dateTimeConvertor : appStateService.currentAppLang()
            )?.split("-")[1]
          }}
        </span>
        )
      </span>
    </div>
  </div>
</div>
